import { Card, Box, Typography, Divider, Skeleton } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// Local Imports

// API services
import { useGetWorkday } from 'services/api/modules/leave/workday'
import { useGetHoliday } from 'services/api/modules/leave/holiday'
import AdxButton from 'components/custom/AdxButton'

const OperationDays = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const workdays = useGetWorkday()
  const holidays = useGetHoliday()
  const totalHoliday =
    holidays?.data?.public_holiday?.filter((item) => item.status === 1)?.length +
    holidays?.data?.custom_holiday?.length

  return (
    <Card
      variant="outlined"
      sx={{
        boxSizing: 'border-box',
        borderRadius: '4.5px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium', minWidth: '130px' }} variant="subtitle1">
            Work Days
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {workdays.isLoading ? (
            <Skeleton width={'100%'} />
          ) : (
            <Typography noWrap variant="subtitle1" color={'alternate.main'}>
              {workdays?.data
                ?.filter((workday) => workday.type !== 'Off Day' && workday.type !== 'Rest Day')
                ?.map((workday, index, { length }) => {
                  if (length - 1 === index) {
                    if (workday.type === 'AM' || workday.type === 'PM') {
                      return `${workday.day} (${workday.type})`
                    }
                    return workday.day
                  } else {
                    if (workday.type === 'AM' || workday.type === 'PM') {
                      return `${workday.day} (${workday.type}), `
                    }
                    return `${workday.day}, `
                  }
                })}
            </Typography>
          )}
        </Box>
      </Box>

      <Divider variant="full" />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
        }}
        p={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium', minWidth: '130px' }} variant="subtitle1">
            Off / Rest Days
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {workdays.isLoading ? (
            <Skeleton width={'100%'} />
          ) : (
            <Typography noWrap variant="subtitle1" color={'alternate.main'}>
              {workdays.data
                .filter((workday) => workday.type === 'Off Day' || workday.type === 'Rest Day')
                .map((workday, index, { length }) => {
                  if (length - 1 === index) {
                    return workday.day
                  } else {
                    return `${workday.day}, `
                  }
                })}
            </Typography>
          )}
        </Box>
      </Box>

      <Divider variant="full" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: 1,
          alignItems: 'center',
        }}
        pl={2}
        pr={2}
      >
        <Box sx={{ width: { xs: 1, sm: 1 / 2 } }}>
          <Typography sx={{ fontWeight: 'medium', minWidth: '130px' }} variant="subtitle1">
            Holidays
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },

            width: { xs: 1, sm: 1 / 2 },
          }}
        >
          {holidays.isLoading ? (
            <Skeleton width={'100%'} />
          ) : (
            <AdxButton
              variant={'ghost'}
              sx={{ p: 0 }}
              disabled={workdays.isLoading || holidays.isLoading}
              onClick={() => {
                navigate('/app/management-centre/company-management/leave/operation-day', {
                  state: {
                    backgroundLocation: location,
                  },
                })
              }}
            >
              <Typography
                variant="subtitle1"
                color={'alternate.main'}
                noWrap
                sx={{ textDecoration: 'underline' }}
              >
                {totalHoliday
                  ? totalHoliday === 1
                    ? `${totalHoliday} day`
                    : `${totalHoliday} days`
                  : 'Not Set'}
              </Typography>
            </AdxButton>
          )}
        </Box>
      </Box>
      <Divider variant="full" />
      <Box sx={{ p: 0.5 }}>
        <AdxButton
          variant={'ghost'}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
          disabled={workdays.isLoading || holidays.isLoading}
          onClick={() => {
            navigate('/app/management-centre/company-management/leave/edit-operation-day')
          }}
        >
          Manage operation days
        </AdxButton>
      </Box>
    </Card>
  )
}

export default OperationDays
